/**
 * Shared builder-session contract used by chat + flow-builder.
 * Protocol (types / SSE / HITL / stream / events) lives here so features
 * do not deep-import each other's internals.
 */

export type {
  BuilderNodeType,
  BuilderNodeData,
  BuilderNode,
  BuilderEdge,
  WorkflowInputField,
  SavedFlow,
  BuilderMessageType,
  BuilderMessage,
  ExecutionLog,
  WorkflowPlan,
  TestRunSummary,
  NodeTestResult,
  PlanFieldMapping,
  PlanMappingGap,
  ValidationPlan,
  ValidationScenario,
  ValidationInput,
  ValidationTriggerMode,
  ValidationInputKind,
  BusinessIntent,
  IntentStatus,
  StructuredIntent,
  ConfirmedAnswer,
  QuestionDraft,
  PendingUserQuestion,
  PendingComposioExec,
  PendingRuntimeInput,
  ReadinessIssue,
} from "./types";

export type { SseFrame } from "./sse";
export { consumeSse, frameText, readResponseError } from "./sse";

export { flowopsApiUrl, flowopsFetch } from "./flowops-api-url";

export {
  beginWorkflowStream,
  rekeyWorkflowStream,
  abortActiveWorkflowStream,
  clearActiveWorkflowStream,
  isWorkflowStreamActive,
  isAbortError,
} from "./active-stream";

export { reconcileSessionHitl } from "./session-hitl";
export { isUserQuestionAnsweredInTranscript } from "./user-question-answered";
export type { ApplySessionHitlResult, SessionHitlSnapshot } from "./session-hitl";
export {
  composioApprovalIdFromMessage,
  settledComposioApprovalIds,
  isComposioApprovalSettled,
  stampConfirmedIntentCards,
} from "./hitl-settled";

export { nodeActivityFromFrame, nodeHighlightFromFrame } from "./node-activity";

export {
  flowBuilderChatHref,
  flowBuilderInstanceKey,
  resolveFlowBuilderSessionId,
} from "./flow-builder-instance-key";

export { clearFlowBuilderSessionUrl, syncFlowBuilderSessionUrl } from "./sync-session-url";

export { notifyDraftsChanged } from "./notify-drafts-changed";

export {
  BuilderSessionEvents,
  emitDraftsChanged,
  onDraftsChanged,
  emitSessionUrl,
  onSessionUrl,
  emitChatLoaded,
  onChatLoaded,
  emitDraftLoaded,
  onDraftLoaded,
  emitChatsChanged,
  onChatsChanged,
  emitOpenWorkflowCanvas,
  onOpenWorkflowCanvas,
  emitWorkflowCanvasVisible,
  onWorkflowCanvasVisible,
  emitWorkspaceTitle,
  onWorkspaceTitle,
  emitValidationStarted,
  onValidationStarted,
} from "./events";
export type { BuilderSessionEventName } from "./events";
